import { Sites } from '@ps/platform-message-framework/common/Sites';
import { select } from '@ps/web-core-store';
import React from 'react';
import { useSelector } from 'react-redux';

import NewUkSignupCountryImage from '../../assets/new-uk-signup-country-image.png';
import SignupCountryDefaultImage from '../../assets/signup-country-default.png';

import { imageContainer } from './SignupCountryImageByLicence.scss';

const SignupCountryImageByLicence = () => {
  const siteId = useSelector(select.cms.getSiteId);

  const getImageByLicence = () => {
    switch (!!siteId) {
      case siteId === Sites.UK:
        return <img src={NewUkSignupCountryImage} width="100%" alt="Welcome" />;
      default:
        return <img src={SignupCountryDefaultImage} width="100%" alt="Welcome" />;
    }
  };

  return <div className={imageContainer}>{getImageByLicence()}</div>;
};

export default SignupCountryImageByLicence;
